// NB: deliberately NOT `// @ts-check` — see the note atop EmbedSim.js.

/**
 * Public entry point for the embeddable widget (#25).
 *
 * Importing this module *registers* `<hexlife-world>` — that is its entire job as a side effect,
 * because the consumer contract is a bare script tag:
 *
 * ```html
 * <script type="module" src="https://sidem.github.io/HexLife/embed/v1/hexlife-embed.js"></script>
 * <hexlife-world ruleset="…32 hex…" seed="1234" rows="64" palette="synthwave"></hexlife-world>
 * ```
 *
 * Registration is idempotent: a page that (say) loads the script twice, or a bundler that pulls it
 * in from two places, must not throw a "name has already been used" DOMException at the host.
 *
 * The named exports exist for programmatic consumers. Devvit consumes the bundled npm entry;
 * script-tag hosts use the Pages/CDN build.
 */

import { HexLifeElement } from './HexLifeElement.js';
import { HexLifeGridElement } from './HexLifeGridElement.js';

export const TAG_NAME = 'hexlife-world';
/** `<hexlife-grid>` — many worlds in one WebGL context. See HexLifeGridElement's header for why. */
export const GRID_TAG_NAME = 'hexlife-grid';

if (typeof customElements !== 'undefined' && !customElements.get(TAG_NAME)) {
    customElements.define(TAG_NAME, HexLifeElement);
}
if (typeof customElements !== 'undefined' && !customElements.get(GRID_TAG_NAME)) {
    customElements.define(GRID_TAG_NAME, HexLifeGridElement);
}

export { HexLifeElement };
export { HexLifeGridElement };
export { EmbedSim, initEmbedWasm } from './EmbedSim.js';
export { EmbedRenderer } from './EmbedRenderer.js';
// A `code` attribute carries a whole world (grid + ruleset + exact cells + exact colors). Consumers
// that need to validate one before mounting it — the Devvit post form does, server-side — want these.
export { decodeWorldCode, encodeWorldCode, isWorldCode } from '../core/WorldCodec.js';
